import { Pressable, StyleSheet, View } from 'react-native'
import Checkbox from 'expo-checkbox';
import Text from 'theme/Text';
import { themedToggleStyles } from 'styles/components/atoms/ThemedToggle';

const CheckBox = ({ onChange, checked, children }) => {

    const onPress = () => {
        if (onChange) {
            onChange(!checked);
        }
    }

    return (
        <Pressable onPress={onPress}>
            <View
                style={ styles.container }>

                <Checkbox
                    style={ styles.checkbox }
                    value={ checked }
                    onValueChange={ onChange }
                />

                <View
                    style={ styles.text }>
                    
                    <Text>{ children }</Text>
                </View>
            </View>

            {/* Overlay over the text (and toggle) so the toggle is not clickable */}
            <View
                style={ themedToggleStyles.overlay }
            />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    checkbox: {
        margin: 8,
    },
    text: {
        flex: 1,
    }
})

export default CheckBox;